/**
 * Capitalizes the first letter of each word in a string,
 * treating underscores, dashes and spaces as separators.
 * @param {string} str - The string to capitalize.
 * @returns {string}
 */
const toTitleCase = str => {
    if (!str) return '';
    return str
        .replace(/[_\-\s]+/g, ' ')
        .trim()
        .split(' ')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
        .join(' ');
};

export default toTitleCase;
